import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface LatestUpdatesProps {
  comics: Comic[];
}

export default function LatestUpdates({ comics }: LatestUpdatesProps) {
  const formatTime = (dateStr: string) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
    if (diffHrs < 24) return `${diffHrs}小时前`;
    const diffDays = Math.floor(diffHrs / 24);
    if (diffDays < 7) return `${diffDays}天前`;
    return dateStr;
  };

  return (
    <section className="py-12 md:py-16 bg-background-100/60" data-product-shop="">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时追踪热门漫画最新章节</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comics.map(comic => {
            const latestChapter = comic.chapters[comic.chapters.length - 1];
            return (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 group"
              >
                <div className="w-16 h-20 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 最新章节在线阅读`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 truncate">
                    {comic.author} · {comic.category}
                  </p>
                </div>
                <div className="flex-shrink-0 text-right">
                  <p className="text-xs text-primary-600 font-medium whitespace-nowrap">
                    {latestChapter.title}
                  </p>
                  <p className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                    {formatTime(comic.updatedAt)}
                  </p>
                </div>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors text-lg"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}